module.exports = vendor_7948134c50988406add6;